import { styled as p } from "@mui/material";
import * as u from "ramda";
import { forwardRef as f, useRef as m, useEffect as y, useCallback as R, useImperativeHandle as v } from "react";
import { jsx as t } from "react/jsx-runtime";
const V = p("video")`
  pointer-events: none;
`, b = (n, s) => {
  const e = m(null), {
    className: a,
    playbackRate: o = 1,
    src: i,
    ...c
  } = n;
  y(() => {
    u.isNotNil(e.current) && (e.current.playbackRate = o);
  }, [o]);
  const l = R((d) => {
    const r = d.target;
    r.currentTime = 0, r.play();
  }, []);
  return v(s, () => e.current), /* @__PURE__ */ t(V, {
    ...c,
    className: a,
    autoPlay: !0,
    muted: !0,
    controls: !1,
    playsInline: !0,
    ref: e,
    onEnded: l,
    children: /* @__PURE__ */ t("source", {
      src: i,
      type: "video/mp4"
    })
  });
}, h = f(b);
export {
  h as default
};
//# sourceMappingURL=ApeironLoopVideo.js.map
